import React, { useContext, useEffect, useState, useCallback } from 'react';
import RMHeader from "../../PageComponentData/wallet/RegularMonthDue/RMHeader";
import { checkMonthlyDue, PayMonthlyDue } from "../../apis";
import { CalcPendingDueRecords} from "./Wallethelperfunction";
import { AppContext } from "../../appContext";
import { HighlightRow, LightRow} from './WalletMiniComponent';
import { EditProfileLoader, Loader } from '../common/loader';
import SimpleButton from '../common/buttons/SimpleButton/SimpleButton';
import ConfirmPopup from '../confirmPopup/ConfirmPopup';
import toast from 'react-hot-toast';
import useRazorpay from 'react-razorpay';
import moment from 'moment';
import LogoImage from '../../Assets/odds_logo_blue.png';

export default function PayMonthlyDueV1({ closeFunction }) {
    const { loggedInUser } = useContext(AppContext);
    const [loader, setLoader] = useState(true);
    const [conformPopUp, setConformPopUp] = useState(false);
    const [loading, setloading] = useState(false);
    const [dueAmountDetails, setDueAmountDetails] = useState(null);
    const [paymentHistory, setPaymentHistory] = useState(null);
    function handelConfirmPopUp() {
        setConformPopUp(!conformPopUp);
    }
    const paymentSuccess = async () => {
        // closeFunction();
        window.location.reload();
        toast.success('Amount paid successfully');
    };
    const toGetOrderId = async () => {
        console.log(dueAmountDetails);
        console.log(dueAmountDetails?.PendingDueRecords);
        // console.log(dueAmountDetails?.PendingDueRecords[0]);
        // console.log(dueAmountDetails?.PendingDueRecords[0]?.item?._id,);

        setloading(true);
        const payload = {
            hospitalId: loggedInUser?.data?.hospitalProfile?._id,
            LedgerId: dueAmountDetails?._id,
        };
        try {
            const res = await PayMonthlyDue(payload);
            if (res.status === 200) {
                const dueAmt = res?.data?.order?.amount_due / 100;
                if (dueAmountDetails?.total_amount === dueAmt) {
                    handlePayment(res?.data?.order?.id);
                }
                setloading(false);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.message || 'Something went wrong');
        } finally {
            setloading(false);
        }
    };
    const [Razorpay] = useRazorpay();
    const handlePayment = useCallback(
        (order) => {
            const order_id = order;
            // Ensure order.id is defined
            if (!order_id) {
                console.error('Order ID is required for payment.');
                return;
            }
            const amountInPaise = order.amount * 100; // Convert amount to paise (smallest currency unit)
            const options = {
                key: process.env.REACT_APP_RAZARPAY_ID, // Your Razorpay key
                amount: amountInPaise.toString(), // Amount in paise
                currency: 'INR',
                name: 'MODO',
                //description: "Test Transaction",
                image: LogoImage, // Uncomment if you have a logo
                order_id: order_id,
                handler: (response) => {
                    console.log('Payment Success', response);
                    handelConfirmPopUp();
                    const payload = {
                        hospitalId: order.hospitalid,
                        razarpayOrderId: order_id,
                    };
                    paymentSuccess(payload);
                },
                prefill: {
                    name: order.name,
                    // email: "youremail@example.com",
                    contact: order.phoneno,
                },
                // notes: {
                //   address: "Razorpay Corporate Office",
                // },
                theme: {
                    color: '#1648CE',
                },
                modal: {
                    ondismiss: () => {
                        handelConfirmPopUp();
                        console.log('Payment Failed or Closed');
                        toast.error('Payment Cancelled');
                        closeFunction();
                    },
                },
            };

            const rzpay = new Razorpay(options);
            rzpay.open();
        },
        [Razorpay]
    );
    const toCheckMonthlyDue = async (id) => {
        try {
            const res = await checkMonthlyDue(id);
            if (res.status === 200) {
                console.log(res);
                setDueAmountDetails(res?.data?.data?.PendingDueRecords[0]?.item);
                if (res?.data?.data?.PendingDueRecords.length > 0) {
                    const result = await CalcPendingDueRecords(res);
                    setPaymentHistory(result);
                    setLoader(false);
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };
    useEffect(() => {
        toCheckMonthlyDue(loggedInUser?.data?.hospitalProfile?._id);
    }, [loggedInUser]);
    return (
        <div className="p-4 lg:p-0 lg:w-[400px]">
            {loader ? (
                <div className="min-h-44 flex justify-center items-center">
                    <Loader />
                </div>
            ) : (
                <>
                    <RMHeader headertxt={'Amount Due'} closeFunction={closeFunction} />
                     <p className="subHeadingText mt-4">
                                  {moment(dueAmountDetails?.createdAt).format('MMMM')} ₹{' '}
                                  {dueAmountDetails?.total_amount}
                                </p>
                    <section className="py-3 space-y-3">
                        <HighlightRow title={'Total Consultation'} data={dueAmountDetails?.TransactionRecord?.length} />
                        <LightRow title={'In-Person'} data={paymentHistory?.inPerson?.total} loopdata={paymentHistory} type={'inPerson'} />
                        <LightRow title={'Virtual'} data={paymentHistory?.virtual?.total} loopdata={paymentHistory} type={'virtual'} />
                        <HighlightRow title={'To Pay'} data={`₹ ${dueAmountDetails?.total_amount}`} />

                    </section>
                    {!loader && (
                        <div className="mt-5 mb-2">
                            <SimpleButton
                                title={`Pay ₹ ${dueAmountDetails?.total_amount}`}
                                buttonType={'primary'}
                                customClass={'w-full rounded-2xl '}
                                onClickEvent={handelConfirmPopUp}
                            />
                        </div>
                    )}
                </>
            )}
            {conformPopUp && (
                <ConfirmPopup
                    message={<p className="baseText">Are you sure you want to make this payment?</p>}
                    popupStatus={conformPopUp}
                    handelConfirmPopUp={handelConfirmPopUp}
                    onclickFunction={toGetOrderId}
                    confirmtext={loading ? <EditProfileLoader /> : 'Yes'}
                    canceltext={'No'}
                />
            )}
        </div>

    )
}